import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from '../../../services/subscription.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { responseIsSuccess } from '../../../shared/helper-functions';
import { openModal, closeModal, closeModalWithoutRemovingBackdrop } from '../../../shared/modal-functions';
import { subscriptionViewSpanish } from '../subscription.static.data';

@Component({
  selector: 'app-manage-payment-method',
  templateUrl: './manage-payment-method.component.html',
  styleUrls: ['../../../app.component.css']  
})
export class ManagePaymentMethodComponent implements OnInit {
  // Static Data
  subscriptionView: any;
  // Control view  
  openModal: any;
  closeModal: any;
  closeModalWithoutRemovingBackdrop: any;
  // User data
  paymentMethodToDelete: string;

  // <p>Package :{{ subscriptionService.customerSubscriptions }}</p>
  
  constructor(public subscriptionService: SubscriptionService, public googleAnalyticsService: GoogleAnalyticsService) {
    this.subscriptionView = subscriptionViewSpanish;
    this.openModal = openModal;
    this.closeModal = closeModal;
    this.closeModalWithoutRemovingBackdrop = closeModalWithoutRemovingBackdrop;
    // subscriptionService.customerSubscriptions[0].PackageDescSpanish.indexOf('Digital') < 0

   }

  ngOnInit() {
  }

  /*
  * Change payment method of the selected subscription
  */
  changePaymentMethod(paymentMethodId) {
    this.subscriptionService.changePaymentMethod(this.subscriptionService.selectedSubscriptionId, paymentMethodId).subscribe(
      (response) => {
        if (responseIsSuccess(response)) {
          this.closeModal('#managePaymentMethodModal');
          this.subscriptionService.getUpdatedSelectedSubscription();
          this.openModal('#successChangePaymentMethodModal');
          this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Validar_Cambio_Metodo_de_Pago');
        }
      },
      (error) => {
        this.openModal('#errorModal');
      });
  }

  /*
   * Remove a specific payment method
   * Display error message when customer tries to delete a payment method that is associated to another subscription that belongs to the customer but it is not the selected one
  */
  deletePaymentMethod() {
    this.subscriptionService.deletePaymentMethod(this.paymentMethodToDelete).subscribe(
      (response) => {
        if (responseIsSuccess(response)) {
          this.closeModalWithoutRemovingBackdrop('#deleteConfirmationModal');
          this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Validar_Eliminacion_Metodo_Pago');
        }
      },
      (error) => {
        if(error.status === 702 || error.status === 704) {
          this.closeModalWithoutRemovingBackdrop('#deleteConfirmationModal');
          this.openModal('#errorDeletePaymentMethodModal');
        } else {
          this.closeModalWithoutRemovingBackdrop('#deleteConfirmationModal');
          this.openModal('#errorModal');
        }
      });
  }

  selectPaymentMethod(paymentMethod) {
    this.subscriptionService.selectedPaymentMethod = paymentMethod;
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/manage-payment-method/manage-payment-method.component.ts